import {makeStyles} from "@material-ui/styles";
import {createStyles, Theme} from "@material-ui/core";
import {Teal} from "orpyx-web-common";

export const usePatientInformationPageStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        marginBottom: "50px",
    },
    title: {
        marginTop: '0',
        fontSize: '20px',
        color: Teal,
    },
    header: {
        zIndex: 99,
    },
    rightAlign: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    patientDetailsHeader: {
        display: 'flex',
        marginLeft: '10px',
        alignItems: 'left',
        fontSize: '20px',
    },
    patientDetailsLineItem: {
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',

        padding: '2px 6px', 
        margin: '2px 0',
    },
    calendarPicker: {
        marginTop: '15px',
    },
    patientDetailsLineItemLabel: {
        minWidth: '75px',
        paddingRight: '10px',
        color: '#fff',
    },
    patientDetailsLineItemValue: {
        maxWidth: '250px',
        flex: '1',
        whiteSpace: 'normal',
        minWidth: '0',
        color: '#000',
    },

    patientDetails: {
        fontWeight: "bold",
    },
    paper: {
        padding: "10px",
    },
    icon: {
        height: "38px",
        color: '#000',
        width: 'initial',
        marginRight: '15px',
    },
    dashboardHeader: {
        backgroundColor: Teal,
        color: 'white',
        padding: '30px 0px',
        borderRadius: '4px',
        alignItems: 'flex-start',
    },
    altText: {
        color: "black",
        marginLeft: '10px',
    },
    border: {
        borderWidth: "3px",
        borderStyle: "solid",
        borderColor: Teal,
        borderRadius: '4px',
        boxShadow: '0 0 5px 0 rgba(232,232,232,0.53)',
        background: '#fff',
        padding: '20px 0',
    },
    horizontalLayout: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:last-child': {
            border: '0'
        }
    },
    centered: {
        alignContent: "center",
        textAlign: "center",
    },
    verticalLayout: {
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
    },
    content: {
        border: '1.08px solid #EFEFEF',
        borderRadius: '3.23px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 7px 14px 0 rgba(0,0,0,0.01), 0 11px 36px 0 rgba(48,48,48,0.16)',
        padding: '27px 20px',
    },
    chart: {
        height: '220px',
    },
    dateLine: {
        display: "flex",
        float: 'right',
        textAlign: 'right',
        fontWeight: 'bold'
    },
    dateItem: {
        color: "#00B6B1",
        textIndent: '0.5em'
    },
    datePicker: {
        width: '200px'
    },
    datePickerNotchedOutline: {
        borderWidth: "1px",
        borderColor: "white !important"
    },
    datePickerLabel: {
        color: "white"
    },
    datePickerInput: {
        padding: '5px'
    },
    href: {
        'text-decoration': 'none',
        color: Teal,
        paddingRight: '20px',
        marginRight: '20px'
    },
    borderRight: {
        borderRight: '1px solid grey'
    },
    bold: {
        fontWeight: 'bold'
    },
    careNoteWrapper: {
        padding: '10px',
        border: '1px solid #ccc',
    },
    careNoteEditor: {
        backgroundColor: 'lightgray',
        padding: '10px',
        border: '1px solid #ccc',
        height: '400px',
        overflowX: 'auto'
    },
    careNoteToolbar: {
        border: '1px solid #ccc'
    },
    careNoteSubmitButton: {
        marginTop: '5px',
        float: 'right',
        width: '84x',
        height: '36px',
        marginLeft: '20px',
        '& span': {
            color: '#FFF',
        },
    },
    clipboardIcon: {
        height: "15px",
        color: '#000',
        width: 'initial',
        marginRight: '5px'
    },
    inventoryIcon: {
        height: "15px",
        color: '#000',
        width: 'initial',
        marginRight: '5px'
    },
    dailyInsightImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
        margin: '0 auto',
        userSelect: 'none',
    },
    dailyInsightNavControl: {
        color: 'black'
    },

    // Shown above the patient header when the patient is paused (OSID-2942). Palette matches the
    // Paused chip in the Inactive patients list (patients-list-table-item.style.ts).
    pausedBanner: {
        padding: '10px 16px',
        marginBottom: '8px',
        borderRadius: '4px',
        backgroundColor: '#FCF2C5',
        color: '#7A5C00',
        fontWeight: 'bold',
        textAlign: 'center',
    },

}));
